"use client";

import { useEffect } from "react";
import { basePath } from "@/lib/basePath";

/**
 * 在 word page hydrate 時 fire-and-forget 打 /api/words/track,記一次瀏覽。
 * 用 useEffect 確保只在實際 mount 後才送(prerender / SSR 階段不會送)。
 * keepalive: 即使使用者馬上跳走,瀏覽器也會把 request 送完。
 */
export default function TrackView({ slug }: { slug: string }) {
  useEffect(() => {
    try {
      fetch(`${basePath}/api/words/track`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ slug }),
        keepalive: true,
      }).catch(() => {
        /* ignore — 只是統計,失敗不影響使用者 */
      });
    } catch {
      /* ignore */
    }
  }, [slug]);

  return null;
}
